module.exports = __webpack_public_path__ + "img/hot dog panameño.a6c42849.jpeg";